import { Modal } from '@/shared/ui'

import styles from './ModerationRulesModal.module.scss'

type ModerationRulesModalProps = {
	open: boolean
	onClose: () => void
}

export const ModerationRulesModal = ({ open, onClose }: ModerationRulesModalProps) => (
	<Modal contentClassName={styles.moderationModal} isOpen={open} onClose={onClose} order={2}>
		<section className={styles.moderationContent}>
			<h2>Правила модерации отзывов</h2>
			<ul>
				<li>Отзыв должен содержать минимум 2 предложения и более 100 символов;</li>
				<li>
					Старайтесь писать развернуто - поделитесь личным опытом использования, достоинствами продукта и конкретными
					фактами;
				</li>
				<li>Нецензурная речь, угрозы, грубость и переход на личности не допускаются;</li>
				<li>
					Запрещены промокоды, ссылки на сторонние сайты, призывы покупать что-то в другом месте или заказные накрутки;
				</li>
				<li>Администрация оставляет за собой право удалять отзывы по собственному усмотрению.</li>
			</ul>
		</section>
	</Modal>
)
